import React, { useState } from "react";
import { Table, Collapse } from "react-bootstrap";
import ReportDetails from "../reportDetails/reportDetails";

import "./reportTable.scss";


const ReportTable = ({ reports, activeTab }) => {
  const [expandedRow, setExpandedRow] = useState(null);

  const filteredReports =
    activeTab === "All"
      ? reports
      : reports.filter((report) => report.status === activeTab);

  return (
    <Table bordered hover className="no-hover-effect">
      <thead>
        <tr>
          <th>From</th>
          <th>Institution</th>
          <th>ISIN</th>
          <th>BPID</th>
          <th>Status</th>
          <th>Date Received</th>
        </tr>
      </thead>
      <tbody>
        {filteredReports.length === 0 ? (
          <tr>
            <td colSpan="6" className="text-center">No reports</td>
          </tr>
        ) : (
          filteredReports.map((report) => (
            <React.Fragment key={report.id}>
              <tr onClick={() => setExpandedRow(expandedRow === report.id ? null : report.id)}>
                <td>{report.from}</td>
                <td>{report.institution}</td>
                <td>{report.isin}</td>
                <td>{report.clients[0].bpId}</td>
                <td>{report.status}</td>
                <td>{report.dateReceived ? report.dateReceived : "N/A"}</td>
              </tr>

              {/* Collapsible row for report details */}
              {expandedRow === report.id && (
                <tr>
                  <td colSpan="6">
                    <Collapse in={expandedRow === report.id}>
                      <div>
                        <ReportDetails 
                          report={{
                            ...report,
                            files: report.documents, 
                          }} 
                        />
                      </div>
                    </Collapse>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))
        )}
      </tbody>
    </Table>
  );
};

export default ReportTable;
